/**
 * Gets the preferred language from browser languages based on available languages.
 * Falls back to the first available language if no match is found.
 * Caches the result for performance.
 * @util
 *
 * @param availableLanguages - Array of available languages from the provider
 * @returns The best matching language code
 * @__NO_SIDE_EFFECTS__
 */
export function getBrowserLanguage(availableLanguages) {
    if (typeof navigator === 'undefined') {
        return undefined;
    }
    const browserLanguages = (navigator.languages || [navigator.language]);
    // First try exact matches
    for (const browserLang of browserLanguages) {
        if (availableLanguages.includes(browserLang)) {
            return browserLang;
        }
    }
    // Then try partial matches (e.g., 'en-US' matches 'en')
    for (const browserLang of browserLanguages) {
        const langCode = browserLang.split('-')[0];
        if (langCode && availableLanguages.includes(langCode)) {
            return langCode;
        }
    }
    return undefined;
}
//# sourceMappingURL=getBrowserLanguage.js.map